import type { ReactNode } from 'react'
import { Card } from '../ui'

/**
 * The next reading's hint (Sprint 1.9.9 D10, O3).
 *
 * The backend's text, verbatim: which rule fired and what it says are the
 * backend's, and the web authors no hint words. There is no "Remind me" until
 * a channel for it is decided (O3).
 */
export function NextReading({ text, secondary, action }: { text: string | null; secondary: string | null; action?: ReactNode }) {
  return (
    <Card as="article" eyebrow="Next reading" className="next">
      {text !== null && (
        <p className="next__text" data-testid="home-hint">
          {text}
        </p>
      )}
      {secondary !== null && <p className="next__secondary">{secondary}</p>}
      {action}
    </Card>
  )
}
